/* eslint-disable no-underscore-dangle */

import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(window.__MUI_X_CHART_LICENSE_KEY__);
